<template>
  <Breadcrumbs
      title="Users"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Users', path: '/users' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <usersListTable/>
    </div>
  </div>
</template>


<script>
import usersListTable from './usersListTable.vue';

export default {
  components: {
    usersListTable
  }
}

</script>